import { apiRequest } from "../index";

export const signup = async (data) => {
  return apiRequest(`/api/auth/signup`, "POST", data);
};

export const login = async (data) => {
  return apiRequest(`/api/auth/login`, "POST", data);
};

export const appleSignIn = async (code) => {
  return apiRequest(`/api/auth/apple/callback?code=${code}`, "GET");
};

export const verifyOTP = async (data) => {
  return apiRequest(`/api/auth/verify-otp`, "POST", data);
};

export const resendOTP = async (data) => {
  return apiRequest(`/api/auth/resend-otp`, "POST", data);
};

export const connectStripeAccount = async (data) => {
  return apiRequest(`/api/auth/connect-account`, "POST", data);
};

export const verifyToken = async (data) => {
  return apiRequest(`/api/auth/verify-token`, "POST", data);
};

export const googleLogin = async (data) => {
  return apiRequest(`/api/auth/google`, "POST", data);
};

export const facebookLogin = async (data) => {
  return apiRequest(`/api/auth/facebook`, "POST", data);
};

export const forgotPassword = async (data) => {
  return apiRequest("/api/auth/forgot-password", "POST", { email: data?.email });
};

export const verifyPasswordResetOTP = async (data) => {
  return apiRequest("/api/auth/verify-password-otp", "POST", {
    email: data?.email,
    code: data?.otp,
  });
};

export const resetPassword = async (data) => {
  return apiRequest("/api/auth/reset-password", "POST", data);
};

// export const resendOTP = async (data) => {
//   return api.post("/auth/resend-password-otp", "POST", data);
// };
